import { useLocation, useNavigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import Constants from "../utils/constants";
import { useEffect } from "react";

const RoleRedirect = ({ children }) => {
    const { ready, auth } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (auth.token == 'Unauthorized' && !ready) {
            navigate('/auth/signin', { replace: true });
        }
        // If path doesn't start with role's prefix, redirect
        else {
            const prefix = Constants.ROLE_PATH_PREFIX[auth?.role?.type] ?? "";
            const path = location.pathname;
            if (!path.startsWith(prefix)) {
                // Remove any existing known prefix before redirecting
                const strippedPath = path.replace(/^\/(cp)/, "");
                navigate(`${prefix}${strippedPath}`, { replace: true });
            }
        }
    }, [auth, ready]);

    return children;
};

export default RoleRedirect;